import { type MapDestination, buildMapUrl, detectMapProvider } from "@offstreetparking/domain/entities/place";

export type ViewMapProps = {
	place: MapDestination;
	children: React.ReactNode;
	tabIndex?: number;
	"aria-label"?: string;
};

export const ViewMap = ({ place, children, tabIndex, "aria-label": ariaLabel }: ViewMapProps) => {
	const mapUrl = buildMapUrl({ destination: place, provider: detectMapProvider() });

	if (!mapUrl) {
		return null;
	}

	return (
		<a
			href={mapUrl}
			target="_blank"
			rel="noopener noreferrer"
			onClick={(e) => e.stopPropagation()}
			tabIndex={tabIndex}
			aria-label={ariaLabel}
		>
			{children}
		</a>
	);
};
